import { getAuthToken } from "../context/auth-context";
import { CALL_API } from "../context/constValues";
export async function getMedicacionesbyLegajo(idlegajo) {
    const token = getAuthToken();
    const response = await fetch(`${CALL_API}/medicacionbyLegajo/${idlegajo}`, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    });
    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message);
    }
  
    return data.result;
  }
  export async function getEvolucionesbylegajo(idlegajo) {
    const token = getAuthToken();
    const response = await fetch(`${CALL_API}/evolucionbyLegajo/${idlegajo}`, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    });
    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.message);
    }
  
    return data.result;
  }
  export async function getInsumoUsadobyLegajo(idlegajo) {
    const token = getAuthToken();
    const response = await fetch(`${CALL_API}/insumousadoyLegajo/${idlegajo}`, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    });
    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message);
    }
  
    return data.result;
  }

export async function getEvolucionesByPaciente(idpaciente) {
  const token = getAuthToken();
  const response = await fetch(`${CALL_API}/evolucionbypaciente/${idpaciente}`, {
    method: "GET",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
    },
  });
  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message);
  }

  return data.result;
}
export async function getMedicacionesbyPaciente(idpaciente) {
  const token = getAuthToken();
  const response = await fetch(`${CALL_API}/medicacionbypaciente/${idpaciente}`, {
    method: "GET",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
    },
  });
  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message);
  }

  return data.result;
}
export async function getInsumoUsadobyPaciente(idpaciente) {
  const token = getAuthToken();
  const response = await fetch(`${CALL_API}/insumousadobypaciente/${idpaciente}`, {
    method: "GET",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
    },
  });
  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message);
  }

  return data.result;
}
export async function getSignosVitalesbyPaciente(idpaciente) {
  const token = getAuthToken();
  const response = await fetch(`${CALL_API}/signosvitalesbypaciente/${idpaciente}`, {
    method: "GET",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
    },
  });
  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message);
  }

  return data.result;
}

export async function getLogsStream() {
   const token = getAuthToken();
   const response = await fetch(`${CALL_API}/logs/ultimos`, {
     method: "GET",
     headers: {
       Authorization: "Bearer " + token,
       "Content-Type": "application/json",
     },
   });
   const data = await response.json();
   if (!response.ok) {
     throw new Error(data.message);
   }

   return data.data;
}
      /* ===================== UPDATE EVOLUCION ===================== */
export async function updateEvolucion(idEvolucion, payload) {
  const token = getAuthToken();

  const response = await fetch(
    `${CALL_API}/updateevolucion/${idEvolucion}`,
    {
      method: "PUT",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    }
  );

  const data = await response.json();
  console.log(data);
  if (!response.ok) {
    throw new Error(data.message);
  }

  return data.result;
}

/* ===================== UPDATE MEDICACION ===================== */
export async function updateMedicacion(idMedicacion, payload) {
  const token = getAuthToken();

  const response = await fetch(
    `${CALL_API}/medicacion/${idMedicacion}`,
    {
      method: "PUT",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    }
  );

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message);
  }

  return data.result;
}

/* ===================== UPDATE INSUMO ===================== */
export async function updateInsumo(idInsumo, payload) {
  const token = getAuthToken();

  const response = await fetch(
    `${CALL_API}/insumousado/${idInsumo}`,
    {
      method: "PUT",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    }
  );

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message);
  }

  return data.result;
}

/* ===================== UPDATE SIGNOS VITALES ===================== */
export async function updateSignosVitales(idSignos, payload) {
  const token = getAuthToken();

  const response = await fetch(
    `${CALL_API}/signosvitales/${idSignos}`,
    {
      method: "PUT",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    }
  );

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message);
  }

  return data.result;
}
